import React from 'react';
import { FaCcVisa, FaCcMastercard, FaGooglePay, FaApplePay } from 'react-icons/fa'; // Specific payment icons from react-icons
import styled from 'styled-components';
import WhatsAppChat from '../common/WhatsAppChat';

// Styled components for the footer
const FooterContainer = styled.footer`
  background-color: #f8f9fa;
  padding: 20px 0 70px; /* Added padding-bottom to account for FooterNav */
  color: #333;
  position: relative;
  z-index: 1; /* Ensure footer sits above the footer nav */
`;

const FooterBottom = styled.div`
  padding: 20px 0;
  border-top: 1px solid #e5e5e5;
`;

const PaymentMethodsRow = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
`;

const PaymentIcons = styled.div`
  display: flex;
  gap: 20px;
`;

const IconWrapper = styled.div`
  font-size: 2rem;
  color: #333;
  display: flex;
  align-items: center;
`;

const CopyrightRow = styled.div`
  text-align: center;
  padding-top: 10px;
`;

const FooterCopy = styled.div`
  font-size: 14px;
  color: #333;
`;

const DevelopedBy = styled.div`
  text-align: center;
  font-size: 14px;
  color: #777;
  margin-bottom: 10px;
`;

// Custom SiteLink styled component
const SiteLink = styled.a`
  text-decoration: none;
  color: #4CAF50;

  &:hover {
    color: #3e8e41;
  }
`;

// Footer component
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterBottom>
        <PaymentMethodsRow>
          <PaymentIcons>
            <IconWrapper>
              <FaCcVisa title="Visa" />
            </IconWrapper>
            <IconWrapper>
              <FaCcMastercard title="MasterCard" />
            </IconWrapper>
            <IconWrapper>
              <FaGooglePay title="Google Pay" />
            </IconWrapper>
            <IconWrapper>
              <FaApplePay title="Apple Pay" />
            </IconWrapper>
          </PaymentIcons>
        </PaymentMethodsRow>

        {/* Developed By Section */}
        {/* Developed By Section */}
        <DevelopedBy>
          Developed by <SiteLink href="https://www.codeteki.au" target="_blank" rel="noopener noreferrer">Codeteki Digital Services</SiteLink>
        </DevelopedBy>

        {/* Copyright Section */}
        <CopyrightRow>
          <FooterCopy>
            Copyright © {currentYear}{' '}
            <SiteLink href="/">
              Hoppers Quality Meats & Grocery
            </SiteLink>
            . All rights reserved.
          </FooterCopy>
        </CopyrightRow>
      </FooterBottom>
      <WhatsAppChat />
    </FooterContainer>
  );
};

export default Footer;